import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import legalAssociationsTerroristOrganizationMemebershipItemValidator from './validators/item';
import { LegalAssociationsInternationalAndDomesticTerrorismModel } from './types';

const legalAssociationsInternationalAndDomesticTerrorismValidator: ValidateJSModel<LegalAssociationsInternationalAndDomesticTerrorismModel> = {
  HasInternationalAndDomesticTerrorism: { presence: true, hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.HasInternationalAndDomesticTerrorism?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalAssociationsTerroristOrganizationMemebershipItemValidator },
      };
    }
    return {};
  },
};

export default legalAssociationsInternationalAndDomesticTerrorismValidator;
